import BenAlertMessage from "./ben-alert-message";

export default BenAlertMessage;
